<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">
        <span>接收人任务详情 - {{ receiveUser }}</span>
        <el-button size="small" @click="goBack" style="margin-left: 16px;">返 回</el-button>
      </div>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-tabs v-model="activeTab" @tab-click="onTabClick">
            <el-tab-pane
              v-for="tab in tabs"
              :key="tab.key"
              :name="tab.key"
            >
              <span slot="label" v-html="tabLabel(tab)"></span>
              <el-table
                v-loading="loading"
                element-loading-text="加载中..."
                :data="pagedRows"
                border
                style="width: 100%"
              >
                <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                <el-table-column prop="title" label="任务标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="address" label="任务地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="addressExtra" label="补充任务地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="下发时间" align="center"></el-table-column>
                <el-table-column prop="endTime" label="截止时间" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <span :style="statusStyle(scope.row.statusTranslated)">{{ scope.row.statusTranslated }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看详情</el-button
                    >
                    <el-button
                      @click="suspenseTask(scope.row)"
                      type="text"
                      size="small"
                      >督促</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="currentTabRows.length"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listAllTask, taskSupervise } from "@/api/src/urbanServerApi";
export default {
  name: "TaskCenterStatDetail",
  controller: "UI",
  action: "TaskCenterStatDetail",
  data() {
    return {
      receiveUser: this.$route.query.receiveUser || "",
      begin: this.$route.query.begin || null,
      end: this.$route.query.end || null,
      loading: false,
      allRows: [],
      activeTab: "全部",
      currentPage: 1,
      pageSize: 20,
      tabs: [
        { key: "全部" },
        { key: "已完成" },
        { key: "处理中" },
        { key: "已逾期" },
      ],
      tabCounts: { 全部: 0, 已完成: 0, 处理中: 0, 已逾期: 0 },
    };
  },
  computed: {
    currentTabRows() {
      if (this.activeTab === "全部") return this.allRows;
      return this.allRows.filter((r) => r.statusTranslated === this.activeTab);
    },
    pagedRows() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.currentTabRows.slice(start, start + this.pageSize);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
      });
    },
    // 拉取与统计页相同时间范围的全部任务，前端按 receiveUser 过滤出本接收人
    loadData() {
      if (!this.receiveUser) {
        this.errmsg("缺少接收人参数");
        return;
      }
      this.loading = true;
      const query = {
        begin: this.begin || undefined,
        end: this.end || undefined,
      };
      listAllTask(query)
        .then(({ rows }) => {
          this.loading = false;
          this.allRows = (rows || []).filter(
            (r) => r.receiveUser === this.receiveUser
          );
          this.calcCounts();
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          this.errmsg("加载失败");
        });
    },
    calcCounts() {
      const counts = { 全部: this.allRows.length, 已完成: 0, 处理中: 0, 已逾期: 0 };
      this.allRows.forEach((r) => {
        if (r.statusTranslated && counts[r.statusTranslated] !== undefined) {
          counts[r.statusTranslated]++;
        }
      });
      this.tabCounts = counts;
    },
    rate(count, total) {
      if (!total) return "0.0%";
      return ((count / total) * 100).toFixed(1) + "%";
    },
    // 全部 tab 只显示数量；其余 tab 显示 数量 + 率（率=该状态数/该接收人总数，1 位小数）
    tabLabel(tab) {
      const count = this.tabCounts[tab.key] || 0;
      if (tab.key === "全部") {
        return tab.key + " (" + count + ")";
      }
      return (
        tab.key +
        " (" +
        count +
        ") <span style='color:#909399;margin-left:4px;'>" +
        this.rate(count, this.allRows.length) +
        "</span>"
      );
    },
    onTabClick() {
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 查看单任务详情
    queryDetail(row) {
      this.$router.push({
        path: "/plugin/TaskCenter/ui/TaskCenterDetails",
        query: { id: row.id, type: "query" },
      });
    },
    // 督办
    suspenseTask(row) {
      taskSupervise({ id: row.id }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.$message({
            type: "success",
            message: "督促成功!",
          });
        }
      });
    },
    goBack() {
      this.$router.back();
    },
    statusStyle(status) {
      const colorMap = {
        已完成: "#67C23A",
        处理中: "#409EFF",
        已逾期: "#F56C6C",
      };
      return { color: colorMap[status] || "#909399" };
    },
  },
};
</script>
